module.exports = __webpack_public_path__ + "img/33ab29c.jpg";